<template>
  <div id="cash-info-modal-template" class="modal__wrap--bg cmp-modal" :class="{'is-active' : showModal}">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">현금 이체 정보</div>
      </div>
      <div class="modal-body-container">
        <div class="table-wrap no-line-mg">
          <table class="table-body-only">
            <caption>현금 이체 정보 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">강좌명</th>
                <td>{{ cashInfo.title }}</td>
              </tr>
              <tr>
                <th scope="row">은행</th>
                <td>{{ cashInfo.bank }}</td>
              </tr>
              <tr>
                <th scope="row">계좌정보</th>
                <td>{{ cashInfo.account }}</td>
              </tr>
              <tr>
                <th scope="row">금액</th>
                <td>{{ cashInfo.amount }}</td>
              </tr>
              <tr>
                <th scope="row">입금계좌명</th>
                <td>{{ cashInfo.owner }}</td>
              </tr>
              <tr>
                <th scope="row">입금자명</th>
                <td>{{ cashInfo.payer }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150  close-modal" @click="close">
          닫기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'cash-info-modal-template',
    props: ['cashInfoModal', 'courseId'],
    data() {
      return {
        cashInfo: {},
        showModal: false,
      };
    },
    watch: {
      cashInfoModal: {
        handler(newVal) {
          if (newVal) {
            this.getCashInfo(this.courseId);
            this.showModal = true;
          } else {
            this.showModal = false;
          }
        },
        immediate: true,
      },
      courseId: {
        handler(newVal) {
          if (newVal && this.cashInfoModal) {
            this.getCashInfo(newVal);
          }
        },
      },
    },
    methods: {
      setButtons() {
        $('.cash-info-btn').on('click', { thisVal: this }, (event) => {
          const varEvent = event;
          const IECheck = this.globalGetInternetExplorerVersion();
          let courseId = '';
          if (IECheck <= 10) {
            courseId = varEvent.currentTarget.getAttribute('data-courseId');
          } else {
            courseId = varEvent.target.dataset.courseid;
          }
          varEvent.data.thisVal.courseid = courseId;
          this.getCashInfo(courseId);
          // $('body').addClass('modal-open');
          this.showModal = true;
        });
      },
      getCashInfo(courseid) {
        axios.get(`/api/courses/${courseid}/cash-info`).then((response) => {
          this.cashInfo = response.data || [];
        }).catch((error) => {
          alert(error.data.msg);
        });
      },
      close() {
        this.showModal = false;
        this.cashInfo = {};
        this.$emit('update:cashInfoModal', false);
        // $('body').removeClass('modal-open');
      },
    },
    mounted() {
      // this.setButtons();
    },
  };
</script>



// WEBPACK FOOTER //
// CashInfoButton.vue?56b36fb5